import { appleLink, googleLink } from '@/constants/download-link';
import React, { useCallback } from 'react';
import Image from 'next/image';
import { isAppleDevice } from '@/shared/utils';

const HomeHero = ({ type, code, ...rest }: { type?: string; code?: string; [key: string]: string }) => {
  const checkAppInstalled = useCallback(() => {
    let appScheme = `aika://`; // 应用 URL Scheme
    if (type && code) {
      appScheme = `aika://lb/${type}?code=${code}`; // 应用 URL Scheme
    }
    const appStoreUrl = {
      ios: appleLink, // iOS 应用商店地址
      android: googleLink, // Android 应用商店地址
    };

    // 尝试打开应用
    window.location.href = appScheme;

    // 设置超时检测（若未跳转，则判定应用未安装）
    setTimeout(() => {
      // 优先使用标准属性，备选方案检测
      // document.addEventListener('visibilitychange', () => {
      //   alert('当前状态:' + document.hidden ? '隐藏' : '可见');
      //   const state = document.visibilityState;
      //   alert(`IOS Visibility changed: ${state} at ${Date.now()}`);
      // });
      if (!document.hidden) {
        // 根据平台跳转到应用商店
        window.location.href = isAppleDevice() ? appStoreUrl.ios : appStoreUrl.android;
      }
    }, 1000); // 超时时间建议 1-2 秒
  }, [code, type]);

  return (
    <div
      className="relative flex h-[1024px] w-full flex-col items-center bg-[url(/images/home/bg.png)] bg-cover bg-center bg-no-repeat"
      {...rest}
    >
      <div className="flex h-[408px] items-end justify-center max-md:h-[383px]">
        <h1 className="text-center text-[92px] font-bold max-xl:text-[62px] max-md:leading-[76px]">Brave New World</h1>
      </div>
      <p className="mt-5 max-w-[1112px] text-center text-[32px] leading-[1.4] font-normal whitespace-pre-wrap opacity-80 max-[700px]:whitespace-normal max-xl:px-3 max-xl:text-[18px] max-md:mt-6">
        {`Create stories, take on challenges, make friends – all of this in AIKA, \na place where technology turns your time into unforgettable moments`}
      </p>
      <div className="hover:animate-twitch absolute top-[37px] left-[158px] z-[1] h-[calc(340/1440*100vw)] max-h-[340px] min-h-[146px] w-[calc(316/1440*100vw)] max-w-[316px] min-w-[136px] select-none max-lg:top-20 max-lg:left-0">
        <Image alt="character" src="/images/home/left-top.png" className="w-full select-none" fill />
      </div>
      <div className="hover:animate-twitch absolute top-[174px] right-[83px] z-[1] h-[calc(252/1440*100vw)] max-h-[252px] min-h-[126px] w-[calc(225/1440*100vw)] max-w-[225px] min-w-[112px] select-none max-lg:top-[110px] max-lg:right-0">
        <Image alt="character" src="/images/home/right-top.png" fill className="w-full select-none" />
      </div>
      <div className="hover:animate-twitch absolute bottom-[130px] z-[1] h-[calc(308/1440*100vw)] max-h-[308px] min-h-[308px] w-[calc(371/1440*100vw)] max-w-[371px] select-none max-md:bottom-[58px] max-md:w-full md:right-0">
        <Image alt="character" src="/images/home/right-bottom.png" className="w-full select-none" fill />
      </div>
      <div className="hover:animate-twitch absolute bottom-[130px] left-1.5 z-[1] h-[calc(476/1440*100vw)] max-h-[476px] w-[calc(405/1440*100vw)] max-w-[405px] select-none max-md:hidden">
        <Image alt="character" src="/images/home/left-bottom.png" fill className="w-full select-none" />
      </div>
      <div className="mt-20 flex justify-center space-x-4 *:max-w-[240px] max-md:mt-10 max-sm:px-4">
        <a
          onClick={checkAppInstalled}
          className="relative z-[2] h-[80px] w-[240px] cursor-pointer duration-200 hover:scale-110 max-xl:h-[56px] max-xl:w-[172px]"
        >
          <Image alt="google play store" src="/images/home/google-store.png" fill className="w-full select-none" />
        </a>
        <a
          onClick={checkAppInstalled}
          className="relative z-[2] h-[80px] w-[240px] cursor-pointer duration-200 hover:scale-110 max-xl:h-[56px] max-xl:w-[172px]"
        >
          <Image alt="apple store" src="/images/home/apple-store.png" fill className="w-full select-none" />
        </a>
      </div>
    </div>
  );
};
export default HomeHero;
